module.exports = __webpack_public_path__ + "img/12_newModelWorker_syr.7bab050d.png";